function getSelected(value, options) {
  return options.map((o) => o.value).sort((a, b) => a - b).find((v) => v >= value);
}

export default getSelected;
